module.exports = __webpack_public_path__ + "img/tron-logo.3a2dc804.svg";